import { useQuery, useSubscription } from "@apollo/react-hooks";
import {
  MY_LEAVE_GET_REQUEST,
  MY_LEAVE_REQUESTS_SUBSCRIPTION,
} from "my-leave/graphql";
import { useOcPolling } from "oc/hooks";

export const useMyLeaveRequest = ({ _id }: { _id: string }) => {
  const { data, loading, error, refetch } = useQuery(MY_LEAVE_GET_REQUEST, {
    fetchPolicy: "cache-and-network",
    pollInterval: useOcPolling(1000 * 60),
    skip: !_id,
    variables: { _id },
  });

  if (error) {
    console.log({
      component: "useLeaveRequest",
      errorDescription:
        "Error occured when fetch data with MY_LEAVE_GET_REQUEST query",
      error: error,
    });
  }

  const { error: subscriptionError } = useSubscription(
    MY_LEAVE_REQUESTS_SUBSCRIPTION,
    {
      onData: () => {
        refetch();
      },
    },
  );

  if (subscriptionError) {
    console.log({
      component: "useLeaveRequest",
      errorDescription:
        "Error occured when subscribe data with MY_LEAVE_REQUESTS_SUBSCRIPTION query",
      error: error,
    });
  }

  let result = {
    leaveRequest: data?.leaveRequest,
    leaveRequestLoading: loading,
    leaveRequestError: error,
  };

  return result;
};

export default useMyLeaveRequest;
